import './ErrorBoundary.scss';

import { ReloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Component, ErrorInfo, ReactNode } from 'react';
import { Translation } from 'react-i18next';

import acronex_logo_md from '@/img/acronex-logo-md.svg';
import { captureReactRenderError } from '@/sentry.config';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Reporta el error de render con componentStack para facilitar el debugging en Sentry.
    captureReactRenderError(error, {
      componentStack: errorInfo.componentStack ?? undefined,
    });

    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="ErrorBoundary">
          <figure className="Logo">
            <img src={acronex_logo_md} alt="" />
          </figure>
          <div className="Label">
            <Translation>{t => t('Ocurrió un error al cargar la página')}</Translation>
          </div>
          <Button
            className="Refresh"
            onClick={() => window.location.reload()}
            icon={<ReloadOutlined />}>
            <Translation>{t => t('Recargar')}</Translation>
          </Button>
        </div>
      );
    }

    return <>{this.props.children}</>;
  }
}

export default ErrorBoundary;
